import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Issues from './pages/Issues';
import IssueDetail from './pages/IssueDetail';
import Articles from './pages/Articles';
import ArticleDetail from './pages/ArticleDetail';
import SubmitArticle from './pages/SubmitArticle';
import About from './pages/About';
import Contact from './pages/Contact';
import EditorialBoard from './pages/EditorialBoard';
import Policies from './pages/Policies';
import AuthorGuide from './pages/AuthorGuide';
import Archive from './pages/Archive';
import FAQ from './pages/FAQ';
import Newsletter from './pages/Newsletter';
import Search from './pages/Search';
import ScientificAdvisors from './pages/ScientificAdvisors';
import ScopeObjectives from './pages/ScopeObjectives';
import History from './pages/History';
import FeaturedArticles from './pages/FeaturedArticles';
import SubmissionProcess from './pages/SubmissionProcess';
import Templates from './pages/Templates';
import EthicsReview from './pages/EthicsReview';
import PublicationTerms from './pages/PublicationTerms';
import OpenAccess from './pages/OpenAccess';
import RelatedJournals from './pages/RelatedJournals';
import RSSFeed from './pages/RSSFeed';
import Sitemap from './pages/Sitemap';
import Feedback from './pages/Feedback';
import Privacy from './pages/Privacy';
import LegalFramework from './pages/LegalFramework';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AdminEditorialBoard from './pages/AdminEditorialBoard';
import AdminAbout from './pages/AdminAbout';
import AdminScopeObjectives from './pages/AdminScopeObjectives';
import AdminScientificAdvisors from './pages/AdminScientificAdvisors';
import AdminIssues from './pages/AdminIssues';
import AdminForAuthors from './pages/AdminForAuthors';
import AdminForReaders from './pages/AdminForReaders';
import AdminInformation from './pages/AdminInformation';
import AdminSlider from './pages/AdminSlider';
import AdminUsers from './pages/AdminUsers';
import AdminReviewers from './pages/AdminReviewers';
import AdminAssignments from './pages/AdminAssignments';
import ReviewerAssignments from './pages/ReviewerAssignments';
import AdminRoles from './pages/AdminRoles';
import AdminPermissions from './pages/AdminPermissions';
import AdminHistory from './pages/AdminHistory';
import AdminPolicies from './pages/AdminPolicies';
import AdminTemplates from './pages/AdminTemplates';
import AdminEthicsReview from './pages/AdminEthicsReview';
import AdminPublicationTerms from './pages/AdminPublicationTerms';
import AdminOpenAccess from './pages/AdminOpenAccess';
import AdminNewsletter from './pages/AdminNewsletter';
import AdminRSSFeed from './pages/AdminRSSFeed';
import AdminRelatedJournals from './pages/AdminRelatedJournals';
import AdminComplaintsSuggestions from './pages/AdminComplaintsSuggestions';
import AdminSubmissionProcess from './pages/AdminSubmissionProcess';
import AdminJournalFeatures from './pages/AdminJournalFeatures';

function AppContent() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/reviewer') || pathname.startsWith('/admin') || pathname === '/admin-login';

  return (
    <div className="flex flex-col min-h-screen">
      {!isAdmin && <Navbar />}
      <main className="flex-grow">
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/issues" element={<Issues />} />
            <Route path="/issues/:id" element={<IssueDetail />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/articles/:id" element={<ArticleDetail />} />
            <Route path="/submit" element={<SubmitArticle />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/editorial-board" element={<EditorialBoard />} />
            <Route path="/scientific-advisors" element={<ScientificAdvisors />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/scope-objectives" element={<ScopeObjectives />} />
            <Route path="/history" element={<History />} />
            <Route path="/featured-articles" element={<FeaturedArticles />} />
            <Route path="/author-guide" element={<AuthorGuide />} />
            <Route path="/submission-process" element={<SubmissionProcess />} />
            <Route path="/templates" element={<Templates />} />
            <Route path="/ethics-review" element={<EthicsReview />} />
            <Route path="/publication-terms" element={<PublicationTerms />} />
            <Route path="/open-access" element={<OpenAccess />} />
            <Route path="/about/legal-framework" element={<LegalFramework />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/search" element={<Search />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/newsletter" element={<Newsletter />} />
            <Route path="/related-journals" element={<RelatedJournals />} />
            <Route path="/rss" element={<RSSFeed />} />
            <Route path="/sitemap" element={<Sitemap />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/admin/articles" element={<AdminDashboard />} />
            <Route path="/admin" element={<Navigate to="/admin/articles" replace />} />
            <Route path="/admin/editorial-board" element={<AdminEditorialBoard />} />
            <Route path="/admin/scientific-advisors" element={<AdminScientificAdvisors />} />
            <Route path="/admin/issues" element={<AdminIssues />} />
            <Route path="/admin/for-authors" element={<AdminForAuthors />} />
            <Route path="/admin/for-readers" element={<AdminForReaders />} />
            <Route path="/admin/information" element={<AdminInformation />} />
            <Route path="/admin/slider" element={<AdminSlider />} />
            <Route path="/admin/journal-features" element={<AdminJournalFeatures />} />
            <Route path="/admin/about" element={<AdminAbout />} />
            <Route path="/admin/scope-objectives" element={<AdminScopeObjectives />} />
            <Route path="/admin/users" element={<AdminUsers />} />
            <Route path="/admin/reviewers" element={<AdminReviewers />} />
            <Route path="/admin/assignments" element={<AdminAssignments />} />
            <Route path="/reviewer/assignments" element={<ReviewerAssignments />} />
            <Route path="/reviewer/assignments/:id" element={<ReviewerAssignments />} />
            <Route path="/admin/roles" element={<AdminRoles />} />
            <Route path="/admin/permissions" element={<AdminPermissions />} />
            <Route path="/admin/history" element={<AdminHistory />} />
            <Route path="/admin/policies" element={<AdminPolicies />} />
            <Route path="/admin/templates" element={<AdminTemplates />} />
            <Route path="/admin/ethics-review" element={<AdminEthicsReview />} />
            <Route path="/admin/publication-terms" element={<AdminPublicationTerms />} />
            <Route path="/admin/submission-process" element={<AdminSubmissionProcess />} />
            <Route path="/admin/open-access" element={<AdminOpenAccess />} />
            <Route path="/admin/newsletter" element={<AdminNewsletter />} />
            <Route path="/admin/rss-feed" element={<AdminRSSFeed />} />
            <Route path="/admin/related-journals" element={<AdminRelatedJournals />} />
            <Route path="/admin/complaints-suggestions" element={<AdminComplaintsSuggestions />} />
          </Routes>
      </main>
      {!isAdmin && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AppContent />
    </Router>
  );
}

export default App;
